import React from "react";
import { FaArrowRight } from "react-icons/fa";
import { animated } from "@react-spring/web";
import "./ReturnButton.style.scss";
import useMove from "./useMove";
import { returnClicked } from "../redux/saturnClickSlice";

const AnimatedIcon = () => {
    const [style, trigger] = useMove({ x: 10 });
    return (
        <animated.div style={style} onMouseEnter={trigger}>
            <FaArrowRight size={20} style={{ marginLeft: "5px" }} />
        </animated.div>
    );
};

const ReturnButton = (props) => {
    // const dispatch = useDispatch();
    const handleReturn = () => {
        props.dispatch(returnClicked());
    };
    return (
        // <div className="returnbutton-container" onClick={handleReturn}>
        //     <div className="returnbutton-icon-container">
        //         {/* <FaArrowLeft size={18} className="returnbutton-icon" /> */}
        //         <AnimatedIcon />
        //     </div>

        //     <div className="returnbutton-text">View All</div>
        // </div>
        <section className="startpage-button-container">
            <div className="startpage-button" onClick={props.onClickFunction ? props.onClickFunction : handleReturn}>
                <span className="startpage-button-text">
                    {props.content}
                    <AnimatedIcon />
                </span>

                <span className="startpage-button-line -right"></span>
                <span className="startpage-button-line -top"></span>
                <span className="startpage-button-line -left"></span>
                <span className="startpage-button-line -bottom"></span>
            </div>
        </section>
    );
};

export default ReturnButton;
